import { createSlice } from "@reduxjs/toolkit";

// prevent everytime login
const initialState = {
  data: [],
  hypoFlag: false,
  symptoms: [],
};

const hypoglycemiaSlice = createSlice({
  name: "hypoglycemiaReducer",
  initialState,
  reducers: {
    setHypoglycemia: (state, action) => {
      state.data = action.payload;
    },
    setSymptoms: (state, action) => {
      state.symptoms = action.payload;
    },
    setHypoFlag: (state, action) => {
      state.hypoFlag = action.payload;
    },
  },
});

export const { setHypoglycemia, setSymptoms, setHypoFlag } =
  hypoglycemiaSlice.actions;
export default hypoglycemiaSlice.reducer;
